export const mobileMaxBreakpoint = 576
export const tabletMinBreakpoint = mobileMaxBreakpoint + 1
export const tabletMaxBreakpoint = 992
export const bigTabletMinBreakpoint = tabletMaxBreakpoint + 1
export const bigTabletMaxBreakpoint = 1199
export const desktopMinBreakpoint = bigTabletMaxBreakpoint + 1

export const isMobileQuery = `(max-width: ${mobileMaxBreakpoint}px)`
export const isTabletQuery = `(min-width: ${tabletMinBreakpoint}px) and (max-width: ${tabletMaxBreakpoint}px)`
export const isTabletMaxQuery = `(max-width: ${tabletMaxBreakpoint}px)`
export const isTabletMinQuery = `(min-width: ${tabletMinBreakpoint}px)`
export const isBigTabletQuery = `(min-width: ${bigTabletMinBreakpoint}px) and (max-width: ${bigTabletMaxBreakpoint}px)`
export const isBigTabletMinQuery = `(min-width: ${bigTabletMinBreakpoint}px)`
export const isBigTabletMaxQuery = `(max-width: ${bigTabletMaxBreakpoint}px)`
export const desktopMinQuery = `(min-width: ${desktopMinBreakpoint}px)`

const mediaQuery = {
  mobile: `@media ${isMobileQuery}`, // from 0 to 576px
  tablet: `@media ${isTabletQuery}`, // from 577px to 992px
  tabletMax: `@media ${isTabletMaxQuery}`, // from 0 to 992px
  tabletMin: `@media ${isTabletMinQuery}`, // from 577px
  bigTablet: `@media ${isBigTabletQuery}`, // from 993px to 1199px
  bigTabletMin: `@media ${isBigTabletMinQuery}`, // from 993px
  bigTabletMax: `@media ${isBigTabletMaxQuery}`, // from 0 to 1199px
  desktopMin: `@media ${desktopMinQuery}`, // from 1200px
}

export default mediaQuery
